"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DrawerContext = exports.ANIMATION_SPEED_EXIT = exports.ANIMATION_SPEED_ENTER = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _reactTransitionGroup = require("react-transition-group");

var _Header = _interopRequireDefault(require("./Header"));

var _Content = _interopRequireDefault(require("./Content"));

var _CloseButton = _interopRequireDefault(require("./CloseButton"));

var _index = require("./index.styles");

var _FocusContainer = _interopRequireDefault(require("./FocusContainer"));

var _excluded = ["skipOpenAnimation", "autoFocus", "noMask", "closeHandler", "children"];

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var ANIMATION_SPEED_ENTER = 200;
exports.ANIMATION_SPEED_ENTER = ANIMATION_SPEED_ENTER;
var ANIMATION_SPEED_EXIT = 125; // Used by Header to close

exports.ANIMATION_SPEED_EXIT = ANIMATION_SPEED_EXIT;
var DrawerContext = /*#__PURE__*/(0, _react.createContext)();
/**
 * Use `Drawer` to display an overlay providing more information.
 */

exports.DrawerContext = DrawerContext;

var Drawer = function Drawer(_ref) {
  var skipOpenAnimation = _ref.skipOpenAnimation,
      autoFocus = _ref.autoFocus,
      noMask = _ref.noMask,
      closeHandler = _ref.closeHandler,
      children = _ref.children,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _useState = (0, _react.useState)(!!skipOpenAnimation),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      inProp = _useState2[0],
      setInProp = _useState2[1];

  var close = function close() {
    return setInProp(false);
  };

  (0, _react.useEffect)(function () {
    setInProp(true);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return /*#__PURE__*/_react["default"].createElement(_index.Container, props, !noMask ? /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.CSSTransition, {
    "in": inProp,
    appear: skipOpenAnimation,
    timeout: 0,
    classNames: "fade-in"
  }, /*#__PURE__*/_react["default"].createElement(_index.Mask, null)) : null, /*#__PURE__*/_react["default"].createElement(_FocusContainer["default"], {
    close: close,
    inProp: inProp,
    noMask: noMask,
    autoFocus: autoFocus
  }, /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.CSSTransition, {
    "in": inProp,
    timeout: {
      appear: 0,
      enter: ANIMATION_SPEED_ENTER,
      exit: ANIMATION_SPEED_EXIT
    },
    classNames: "slide-aside"
  }, /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.CSSTransition, {
    "in": inProp,
    appear: skipOpenAnimation,
    timeout: {
      appear: 0,
      enter: ANIMATION_SPEED_ENTER,
      exit: ANIMATION_SPEED_EXIT
    },
    classNames: "slide-in",
    onExited: closeHandler
  }, /*#__PURE__*/_react["default"].createElement(_index.DrawerContent, {
    "data-testid": "content",
    "data-drawer": true
  }, /*#__PURE__*/_react["default"].createElement(DrawerContext.Provider, {
    value: {
      close: close
    }
  }, children))))));
};

Drawer.propTypes = {
  skipOpenAnimation: _propTypes.bool,
  autoFocus: _propTypes.bool,
  noMask: _propTypes.bool,
  closeHandler: _propTypes.func.isRequired,
  children: _propTypes.node.isRequired
};
Drawer.defaultProps = {
  skipOpenAnimation: false,
  autoFocus: false,
  noMask: false
};
Drawer.Header = _Header["default"];
Drawer.Content = _Content["default"];
Drawer.CloseButton = _CloseButton["default"];
var _default = Drawer;
exports["default"] = _default;